var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"authentication"}),_c('div',{staticClass:"scan-img"},[_c('van-image',{staticClass:"scan-img",attrs:{"src":_vm.bgUrl}})],1),_c('div',{staticStyle:{"margin-top":"10px","height":"500px","text-align":"center"}},[_c('h3',[_vm._v(_vm._s(this.time)+"秒后将关闭页面")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }